export default function findCollection(record) {
  const educatorsRoles = ['District Admin', 'School Admin', 'Teacher']
  const studentsRoles = ['Student']
  if (record.role) {
    if (educatorsRoles.indexOf(record.role) > -1) {
      return 'educators'
    } else if (studentsRoles.indexOf(record.role) > -1) {
      return 'students'
    } else return null
  } else {
    if (record.schools) {
      return 'districts'
    } else if (record.teachers) {
      return 'schools'
    } else if (record.teacher && record.students) {
      return 'classes'
    } else return null
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/findCollection.js